<template>
  <b-dropdown rnd-id="lang" hoverable aria-role="list">
    <img
      slot="trigger"
      :src="require(`@/assets/images/flags/${language.flag}.png`)"
      :alt="$i18n.locale"
    />

    <b-dropdown-item aria-role="listitem" @click="handleSetLanguage('de')">
      <div rnd-id="lang-de" class="media">
        <img class="media-left" src="@/assets/images/flags/de.png" alt="de" />
        <div class="media-content">
          <p>Deutsch</p>
        </div>
      </div>
    </b-dropdown-item>
    <b-dropdown-item aria-role="listitem" @click="handleSetLanguage('en')">
      <div rnd-id="lang-en" class="media">
        <img class="media-left" src="@/assets/images/flags/en.png" alt="en" />
        <div class="media-content">
          <p>English</p>
        </div>
      </div>
    </b-dropdown-item>
    <b-dropdown-item aria-role="listitem" @click="handleSetLanguage('fr')">
      <div rnd-id="lang-fr" class="media">
        <img class="media-left" src="@/assets/images/flags/fr.png" alt="fr" />
        <div class="media-content">
          <p>Français</p>
        </div>
      </div>
    </b-dropdown-item>
    <b-dropdown-item aria-role="listitem" @click="handleSetLanguage('it')">
      <div rnd-id="lang-it" class="media">
        <img class="media-left" src="@/assets/images/flags/it.png" alt="it" />
        <div class="media-content">
          <p>Italiano</p>
        </div>
      </div>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
export default {
  name: "lang-select",
  computed: {
    language() {
      const locale = this.$store.getters.language;
      this.$moment.locale(locale);

      if (locale === "en") {
        return {
          flag: "en",
          lang: "English",
        };
      } else if (locale === "fr") {
        return {
          flag: "fr",
          lang: "Français",
        };
      } else if (locale === "de") {
        return {
          flag: "de",
          lang: "Deutsch",
        };
      } else if (locale === "it") {
        return {
          flag: "it",
          lang: "Italiano",
        };
      }
    },
  },
  methods: {
    handleSetLanguage(lang) {
      this.$i18n.locale = lang;
      this.$store.dispatch("setLanguage", lang);
    },
  },
};
</script>

<style lang="scss">
.navbar-item {
  img {
    width: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/land-select/LangSelect.vue